export const NO_SCROLL = "no-scroll";

/**
 * @param {intl} intl
 * @param {Object.<Object>} messages
 * @description Get locale messages. Using intl.formatMessage().
 */
export const getLocaleMessages = (intl, messages) =>
  messages.map((message) => intl.formatMessage(message));

/**
 * @param {Object.<Object>} object
 * @param {Array.<string>} keys
 * @param {boolean} trim
 * @return {array}
 * @description Get array by object keys.
 *
 * @example
 * // ["X"]
 * getArrayByKeys({ pointX: " X ", pointY: " Y "}, ["pointX"], true)
 */
export const getArrayByKeys = (object, keys, trim = false) =>
  keys.map(
    (key) =>
      (typeof object[key] === "string" && trim
        ? object[key].trim()
        : object[key]) || ""
  );

/**
 * @param {string} url
 * @description Preload image
 */
export const preloadImage = (url) =>
  new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve();
    image.onerror = () => resolve();
    image.src = url;
  });

/**
 * @param {Array.<string>} urls
 * @description Preload images
 */
export const preloadImages = (urls) => Promise.all(urls.map(preloadImage));

/**
 *
 * @type {Element}
 */
export const root = document.body.children[0];

/**
 * @param {HTMLElement} el
 * @param {boolean} value
 * @description Display scroll on root element
 */
export const displayScroll = (el, value = true) =>
  value ? el.classList.add(NO_SCROLL) : el.classList.remove(NO_SCROLL);

/**
 * @param {Array <Object>} arr
 * @description Filter array by `games_count`
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const filterByCountOfGames = (arr) =>
  arr.filter(({ games_count = 0 }) => games_count > 0);

/**
 * @param {string} eventName
 * @param {(Object, null)} detail
 * @description Dispatch document event
 */
export const dispatchEvent = (eventName, detail = null) => {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
};
